import React, {useState} from 'react';
import PropTypes from "prop-types";
import {getChildByType, getChildrenByType} from 'react-nanny';

const ProposalTab = ({__TYPE, children, disabled, completed}) => {
    return (
        <div className={TB.mapClass("proposal-tab-content", {completed, disabled})}>
            {children}
        </div>
    )
};
const ProposalSubject = ({__TYPE, children, disabled}) => {
    return (
        <div className={TB.mapClass("proposal-subject", {disabled})}>
            {children}
        </div>
    )
};

const ProposalMessages = ({__TYPE, children, disabled}) => {
    return (
        <div className={TB.mapClass("proposal-messages", {disabled})}>
            {children}
        </div>
    )
};

ProposalTab.defaultProps = {
    __TYPE: 'ProposalTab',
};
const Proposal = (
    {
        project,
        subject,
        isDisabled,
        onExit,
        backBtnTitle,
        children,
        header,
        subheader,
        editable,
        stepHeader,
        lastUpdated,
        ...props
    }) => {
    const Tabs = getChildrenByType(children, [ProposalTab])

    const tabKeys = Tabs.map(tab => tab.props.tabKey);

    const [activeTab, setActiveTab] = useState(TB.first(tabKeys));

    return (
        <div className="proposal-container">

            {stepHeader && (
                <div className="proposal-step-header">
                    {stepHeader}
                </div>
            )}

            {(header || subheader) && (
                <div className="proposal-header">
                    {onExit && (
                        <button className="btn btn-link-primary proposal-back-btn" onClick={onExit}>
                            <i className="fa fa-angle-left mr-2"/>
                            {backBtnTitle}
                        </button>
                    )}
                    <h2 className="mb-0">
                        {header}

                        {lastUpdated && (
                            <small className="ml-3">Last updated: {TB.moment(lastUpdated).fromNow()}</small>
                        )}
                    </h2>
                    {subheader && (
                        <p className="mt-2 mb-0">
                            {subheader}
                        </p>
                    )}
                </div>
            )}


            <div className="proposal-overview flex-col md:flex-row">
                {getChildByType(children, [ProposalSubject])}

                <div className="proposal-tabs-section">
                    <div className="proposal-tabs">
                        {Tabs.map(({props: {tabKey, disabled, completed, stepNumber, badgeLeft, badgeRight}}) => {
                            const isActive = props.activeTab ? props.activeTab === tabKey : activeTab === tabKey;
                            return (
                                <div onClick={props.onSetActiveTab ? () => props.onSetActiveTab(tabKey) : () => setActiveTab(tabKey)}
                                     key={tabKey + (completed ? 'c-' : 'u-') + 'tab'}
                                     className={
                                         TB.mapClass('proposal-tab', {
                                             disabled,
                                             completed,
                                             'active': isActive
                                         })}>

                                    {badgeLeft}
                                    {stepNumber && (
                                        <span className="step-number">{(!isActive && completed) ? (
                                            <i className="fas fa-check"/>
                                        ): stepNumber}</span>
                                    )}
                                    {tabKey}
                                    {badgeRight}
                                </div>
                            )
                        })}

                    </div>

                    {TB.find(Tabs, ['props.tabKey', props.activeTab ? props.activeTab : activeTab])}

                </div>


                {getChildByType(children, [ProposalMessages])}

            </div>
        </div>
    );
};

Proposal.propTypes = {
    isDisabled: PropTypes.bool,
    project: PropTypes.object,
    onSelected: PropTypes.func,
    onExit: PropTypes.any,
    candidate: PropTypes.any,
    backBtnTitle: PropTypes.any
};

export {
    ProposalTab,
    ProposalSubject,
    ProposalMessages
}
export default Proposal;
